import { useMemo } from "react";
export const useEnabledProperties = (location, enabled) => useMemo(() => enabled.filter((f) => {
    const [list, value] = f.split(".");
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    try {
        // @ts-expect-error
        return location[list].includes(value);
    }
    catch (err) {
        throw new Error(`CONFIG ERROR: Enabled property key '${f}' is invalid.`);
    }
}), [location, enabled]);
